import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { resendVerification } from '../services/registrationApi'

export default function CheckYourEmailPage() {
  const { state } = useLocation()
  const email: string = (state as { email?: string })?.email ?? ''

  const [resent, setResent] = useState(false)
  const [resending, setResending] = useState(false)

  const handleResend = async () => {
    if (!email || resending) return
    setResending(true)
    try {
      await resendVerification(email)
      setResent(true)
    } finally {
      setResending(false)
    }
  }

  return (
    <div className="min-h-screen bg-rd-bg font-dmSans flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center text-3xl mx-auto mb-6"
          style={{ background: 'linear-gradient(135deg, #4ade80, #22d3ee)' }}
        >
          ✉️
        </div>

        <h1 className="font-sora font-bold text-2xl text-rd-text mb-3">Check your email</h1>
        <p className="text-rd-muted text-sm mb-2">
          We sent a verification link to
        </p>
        {email && (
          <p className="text-rd-text font-medium mb-6">{email}</p>
        )}
        <p className="text-rd-muted text-sm mb-8">
          Click the link in the email to activate your account. It expires in 24 hours.
        </p>

        <div className="bg-rd-surface border border-white/[0.07] rounded-xl p-5 text-left mb-6">
          <p className="text-rd-muted text-xs mb-1 font-medium uppercase tracking-wide">Didn't get it?</p>
          <p className="text-rd-muted text-sm mb-3">Check your spam folder, or resend the link.</p>
          {resent ? (
            <p className="text-green-400 text-sm font-medium">✓ A new verification email has been sent.</p>
          ) : (
            <button
              onClick={handleResend}
              disabled={resending || !email}
              className="text-sm font-semibold text-rd-text underline disabled:opacity-40 disabled:cursor-not-allowed"
            >
              {resending ? 'Sending…' : 'Resend verification email'}
            </button>
          )}
        </div>

        <Link to="/login" className="text-rd-muted text-sm hover:text-rd-text transition-colors">
          Back to login
        </Link>
      </div>
    </div>
  )
}
